import { Modal } from "@common/Modal/Modal";
import { Button, Grid, Typography } from "@material-ui/core";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import UpdateContactNumber from "./UpdateContactNumber";

interface IParams {
    mobileNumber: string;
}

const UserContactNumber = (props: IParams) => {
    const [isEditing, setIsEditing] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation("profile");
    const { mobileNumber } = props;

    const onFinishUpdate = () => {
        setIsEditing(false);
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <Modal
                close={closeModal}
                confirm={closeModal}
                content={<Trans i18nKey="contactNumberChangeSuccess" ns="profile" />}
                isModalOpen={isModalOpen}
                title={t("updateContactNumber")}
            />
            <Grid alignItems="center" className="mydetail__fields" container item spacing={1}>
                <Grid item sm={4} xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography color="textSecondary" id="detailEmail" variant="body2">
                                {t("contactNumber")}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography aria-labelledby="detailEmail" noWrap variant="body1">
                                {mobileNumber}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={8} xs={12}>
                    <Button
                        color="secondary"
                        size="large"
                        type="button"
                        variant="contained"
                        onClick={() => setIsEditing(true)}
                    >
                        {t("updateContactNumber")}
                    </Button>
                </Grid>
            </Grid>
            {isEditing && (
                <UpdateContactNumber handleCancelClick={() => setIsEditing(false)} onFinishUpdate={onFinishUpdate} />
            )}
        </>
    );
};

export default UserContactNumber;
